module.exports = __webpack_public_path__ + "static/img/3.44cb002.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/3/zh/3.png
// module id = WG/y
// module chunks = 0